import React, { useEffect, useState } from 'react';
import { Card, CardContent, Box, Typography, Chip, CircularProgress } from '@mui/material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../contexts/AuthContext';

const EnergyStatusCard = () => {
  const { currentSiteId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [meterCount, setMeterCount] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!currentSiteId) {
        setMeterCount(null);
        return;
      }

      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5008';
        const res = await fetch(`${baseUrl}/api/energy/n3rgy/${currentSiteId}/mpxns`);

        if (!res.ok) {
          setMeterCount(0);
          return;
        }
        const data = await res.json().catch(() => ({}));

        let count = 0;
        if (Array.isArray(data)) {
          count = data.length;
        } else if (Array.isArray(data.items)) {
          count = data.items.length;
        } else if (typeof data.totalResults === 'number') {
          count = data.totalResults;
        }

        setMeterCount(count);
      } catch (err) {
        setMeterCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [currentSiteId]);

  const isConnected = typeof meterCount === 'number' && meterCount > 0;

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                bgcolor: isConnected ? 'success.light' : 'warning.light',
                borderRadius: '50%',
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ElectricBoltIcon
                sx={{ color: isConnected ? 'success.main' : 'warning.main' }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                Smart Meter Connection
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Status of your n3rgy smart meter link for this site.
              </Typography>
            </Box>
          </Box>
          {loading ? (
            <CircularProgress size={20} />
          ) : isConnected ? (
            <Chip
              icon={<CheckCircleIcon />}
              label="Connected"
              color="success"
              size="small"
            />
          ) : (
            <Chip
              icon={<ErrorOutlineIcon />}
              label="Not Connected"
              color="warning"
              size="small"
            />
          )}
        </Box>

        {!loading && isConnected && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            ✅ Smart meter connected via n3rgy ({meterCount} meter{meterCount === 1 ? '' : 's'}).
          </Typography>
        )}

        {!loading && !isConnected && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            ⚠ Smart meter not connected yet. Go to the Energy settings or the n3rgy consent portal to grant access and link the
            correct meter(s) for this site.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default EnergyStatusCard;

